import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import EquipmentApi from '@/services/apiServiceModules/equipmentApi'
const equipmentApi = new EquipmentApi()

export default class EquipmentDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.EQUIPMENT, equipmentApi, {
			useCache: true,
		})
	}
}
